import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { asyncAction } from 'store/utils/promiseAction';
import {
  OrdersTypes,
  OrderInterface,
  ChargeRequestInterface,
} from './types';

// Get Order
export const getOrderRequest = (payload: object) =>
  action(OrdersTypes.GET_ORDER_REQUEST, payload);
export const getOrderSuccess = (payload: { chargeRequestData: OrdersTypes }) =>
  action(OrdersTypes.GET_ORDER_SUCCESS, payload);
export const getOrderFailure = () => action(OrdersTypes.GET_ORDER_FAILURE);

// List Orders
export const listOrdersRequest = (payload: any) =>
  action(OrdersTypes.LIST_ORDERS_REQUEST, payload);
export const listOrdersSuccess = (payload: {
  chargeRequestList: ChargeRequestInterface[];
  totalCount: number;
}) => action(OrdersTypes.LIST_ORDERS_SUCCESS, payload);
export const listFullOrdersSuccess = (payload: {
  chargeRequestListFull: ChargeRequestInterface[];
  totalCount: number;
}) => action(OrdersTypes.LIST_FULL_ORDERS_SUCCESS, payload);
export const listOrdersFailure = () => action(OrdersTypes.LIST_ORDERS_FAILURE);

// List Orders
export const asyncListOrdersRequest = (payload: any) =>
  asyncAction(OrdersTypes.ASYNC_LIST_ORDERS_REQUEST, payload);
export const asyncListOrdersSuccess = (payload: {
  chargeRequestList: ChargeRequestInterface[];
  totalCount: number;
}) => action(OrdersTypes.ASYNC_LIST_ORDERS_SUCCESS, payload);
export const asyncListFullOrdersSuccess = (payload: {
  chargeRequestListFull: ChargeRequestInterface[];
  totalCount: number;
}) => action(OrdersTypes.LIST_FULL_ORDERS_SUCCESS, payload);
export const asyncListOrdersFailure = () =>
  action(OrdersTypes.ASYNC_LIST_ORDERS_FAILURE);

// Create Order
export const createOrderRequest = (payload: OrderInterface) =>
  asyncAction(OrdersTypes.CREATE_ORDER_REQUEST, payload);
export const createOrderSuccess = (payload: {
  chargeRequestData: OrdersTypes;
}) => action(OrdersTypes.CREATE_ORDER_SUCCESS, payload);
export const createOrderFailure = () =>
  action(OrdersTypes.CREATE_ORDER_FAILURE);

// Repeat Order
export const repeatOrderRequest = (payload: object) =>
  action(OrdersTypes.CHARGE_REQUEST_REPEAT_ORDER_REQUEST, payload);
export const repeatOrderSuccess = (payload: {
  chargeRequestRepeatData: ChargeRequestInterface;
}) => action(OrdersTypes.CHARGE_REQUEST_REPEAT_ORDER_SUCCESS, payload);
export const repeatOrderFailure = () =>
  action(OrdersTypes.CHARGE_REQUEST_REPEAT_ORDER_FAILURE);

// Delete Order
export const deleteOrderRequest = (payload: object) =>
  action(OrdersTypes.DELETE_ORDER_REQUEST, payload);
export const deleteOrderSuccess = () =>
  action(OrdersTypes.DELETE_ORDER_SUCCESS);
export const deleteOrderFailure = () =>
  action(OrdersTypes.DELETE_ORDER_FAILURE);

// Get OrderPdf
export const getOrderPdfRequest = (payload: {
  chargeRequestId: string;
  url?: string;
}) => action(OrdersTypes.GET_ORDER_PDF_REQUEST, payload);
export const getOrderPdfSuccess = (payload: { chargeBoleto: string }) =>
  action(OrdersTypes.GET_ORDER_PDF_SUCCESS, payload);
export const getOrderPdfFailure = () =>
  action(OrdersTypes.GET_ORDER_PDF_FAILURE);

// Filter Orders
export const filterOrdersRequest = (payload: object) =>
  action(OrdersTypes.FILTER_ORDER_REQUEST, payload);
export const filterOrdersSuccess = (payload: {
  chargeRequestList: ChargeRequestInterface[];
}) => action(OrdersTypes.FILTER_ORDER_SUCCESS, payload);
export const filterOrdersFailure = () =>
  action(OrdersTypes.FILTER_ORDER_FAILURE);
// Charge Request Pay Boleto
export const chargeRequestPayBoletoOrderRequest = (payload: {
  attachment: File[];
}) => action(OrdersTypes.CHARGE_REQUEST_PAY_BOLETO_ORDER_REQUEST, payload);
export const chargeRequestPayBoletoOrderSuccess = () =>
  action(OrdersTypes.CHARGE_REQUEST_PAY_BOLETO_ORDER_SUCCESS);
export const chargeRequestPayBoletoOrderFailure = () =>
  action(OrdersTypes.CHARGE_REQUEST_PAY_BOLETO_ORDER_FAILURE);

// Charge Request Pay
export const chargeRequestPayOrderRequest = (payload: {
  body: {
    attachment: File[];
    chargeRequestId: string;
  };
  isLastRequest?: boolean;
  listOrdersParams?: Object;
}) => action(OrdersTypes.CHARGE_REQUEST_PAY_ORDER_REQUEST, payload);
export const chargeRequestPayOrderSuccess = () =>
  action(OrdersTypes.CHARGE_REQUEST_PAY_ORDER_SUCCESS);
export const chargeRequestPayOrderFailure = () =>
  action(OrdersTypes.CHARGE_REQUEST_PAY_ORDER_FAILURE);
